function init() {}
function onSuspendedLogin() {}
module.exports = {
  init: init,
  onSuspendedLogin: onSuspendedLogin
};